<template>
  <v-app>
    <v-container fluid class="pa-0">
      <v-row v-if="$insertAccess($route.fullPath)">
        <v-col cols="12">
          <!-- Employee Selection Section -->
          <v-expansion-panels v-model="panel" class="mb-1">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Employee Selection
              </v-expansion-panel-title>
              <v-expansion-panel-text class="pa-0">
                <v-form ref="employeeForm" id="employeeForm" class="pa-0">
                  <v-row class="ma-0">
                    <v-col lg="6" md="6" cols="12" class="pa-1">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="employee_id"
                        :items="employees"
                        :item-title="(item) => `${item.name} - ${item.code || item.employee_code || item.emp_id || ''}`"
                        item-value="id"
                        :loading="employeesLoading"
                        autocomplete="off"
                        clearable
                        hide-details="auto"
                        @update:model-value="loadEmployeeDetails"
                        no-data-text="No employees found"
                        placeholder="Select an employee"
                      >
                        <template #label>
                          Employee
                          <span class="text-red-accent-4">*</span>
                        </template>
                        <template #append-inner>
                          <v-btn
                            icon="mdi-refresh"
                            size="small"
                            variant="text"
                            @click="loadEmployees"
                            :loading="employeesLoading"
                          ></v-btn>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col lg="6" md="6" cols="12" class="pa-1 d-flex align-center">
                      <v-chip 
                        v-if="employees.length > 0" 
                        color="success" 
                        size="small"
                      >
                        {{ employees.length }} employees loaded
                      </v-chip>
                      <v-chip 
                        v-else-if="!employeesLoading" 
                        color="warning" 
                        size="small"
                      >
                        No employees found
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>


                  <!-- Employee Details Display -->
          <v-expansion-panels v-model="panel1" class="mt-0 mb-1" v-if="employeeDetails.name">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Employee Details
              </v-expansion-panel-title>
              <v-expansion-panel-text class="pa-0">
                <v-card variant="outlined" class="pa-0">
                    <v-card-title class="text-subtitle-1 mb-0 pa-1">
                      <v-icon class="me-1" size="small">mdi-account</v-icon>
                      Employee Information
                    </v-card-title>
                    <v-form class="pa-0">
                      <v-row class="ma-0">
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.emp_id"
                            label="EMP ID"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.name"
                            label="Name"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.department"
                            label="Department"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.designation"
                            label="Designation"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.joining_date"
                            label="Joining Date"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.mobile"
                            label="Mobile"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.email"
                            label="Email"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.employee_type"
                            label="Employee Type"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Increment Form Section -->
          <v-expansion-panels v-model="panel2" class="mt-0" multiple>
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Add Increment Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit" ref="addIncrement" id="addIncrement">

                    <!-- Increment Details Section -->
                  <v-card variant="outlined" class="pa-1 mb-1">
                    <v-card-title class="text-subtitle-1 mb-0 pa-1">
                      <v-icon class="me-1" size="small">mdi-trending-up</v-icon>
                      Increment Details
                    </v-card-title>
                    <v-form class="pa-0">
                      <v-row class="ma-0">
                        <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-text-field
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                            v-model="ref_no"
                        autocomplete="off"
                        clearable
                            hide-details="auto"
                      >
                        <template #label>
                              Ref No.
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>
                        </v-col>

                        <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                            v-model="increment_type"
                        :items="incrementTypes"
                        :item-title="(item) => `${item.text}`"
                        item-value="value"
                        :loading="loading"
                        autocomplete="off"
                        clearable
                            hide-details="auto"
                      >
                        <template #label>
                          Increment Type
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                        </v-col>

                        <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-date-input
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="increment_date"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        autocomplete="off"
                        hide-details="auto"
                        clearable
                      >
                        <template #label>
                          Increment Date
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-date-input>
                        </v-col>

                        <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-date-input
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="effect_date"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        autocomplete="off"
                        hide-details="auto"
                        clearable
                      >
                        <template #label>
                          Effect Date
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-date-input>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>

                  <!-- Salary Information Comparison -->
                  <v-row class="ma-0">
                    <!-- Before Increment Section -->
                    <v-col lg="6" md="6" cols="12">
                      <v-card variant="outlined" class="pa-1">
                        <v-card-title class="text-subtitle-1 mb-0 pa-1">
                          <v-icon class="me-1" size="small">mdi-currency-usd</v-icon>
                          Before Increment (Salary Information)
                        </v-card-title>
                        <v-form class="pa-0">
                          <v-row class="ma-0">
                            <v-col cols="12" class="pa-1">
                              <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                                v-model="beforePackage"
                                :items="packageOptions"
                                :item-title="(item) => `${item.name}`"
                                item-value="id"
                        autocomplete="off"
                                clearable
                                hide-details="auto"
                              >
                                <template #label>Package</template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>

                          <!-- Salary Components -->
                          <v-row class="pa-1">
                            <v-col cols="6">
                      <v-text-field
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                                v-model="beforeGrossSalary"
                                label="Gross Salary"
                        type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeBasic"
                                label="Basic"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeHouseRent"
                                label="House Rent"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeMedical"
                                label="Medical"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeEducation"
                                label="Education"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeMobile"
                                label="Mobile"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeTransport"
                                label="Transport"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeTechnical"
                                label="Technical"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeFestival"
                                label="Festival"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeTiffin"
                                label="Tiffin"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeWash"
                                label="Wash"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeIncentive"
                                label="Incentive"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeOthers"
                                label="Others"
                                type="number"
                                readonly
                              />
                            </v-col>
                          </v-row>

                          <!-- Deduction Section -->
                          <v-divider class="my-4"></v-divider>
                          <v-card-title class="text-subtitle-2 bg-grey-lighten-4 pa-2">Deduction</v-card-title>
                          <v-row class="pa-1">
                            <v-col cols="6">
                      <v-text-field
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                                v-model="beforeTaxDeduct"
                                label="Tax Deduct"
                        type="number"
                        readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforePF"
                                label="PF"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeCarUse"
                                label="Car Use"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeGasBill"
                                label="Gas Bill"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeElectricityBill"
                                label="Electricity Bill"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeTelephoneBill"
                                label="Telephone Bill"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeInsurance"
                                label="Insurance"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeOthersDeduct"
                                label="Others Deduct"
                                type="number"
                                readonly
                              />
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card>
                    </v-col>

                    <!-- After Increment Section -->
                    <v-col lg="6" md="6" cols="12">
                      <v-card variant="outlined" class="pa-1">
                        <v-card-title class="text-subtitle-1 mb-0 pa-1">
                          <v-icon class="me-1" size="small">mdi-trending-up</v-icon>
                          After Increment (Salary Information)
                        </v-card-title>
                        <v-form class="pa-0">
                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-1">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="afterPackage"
                        :items="packageOptions"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        autocomplete="off"
                        clearable
                        hide-details="auto"
                      >
                                <template #label>Package</template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>

                          <!-- Salary Components -->
                          <v-row class="pa-1">
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterGrossSalary"
                                label="Gross Salary"
                                type="number"
                                placeholder="Join Gross Salary"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterBasic"
                                label="Basic"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterHouseRent"
                                label="House Rent"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterMedical"
                                label="Medical"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterEducation"
                                label="Education"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterMobile"
                                label="Mobile"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTransport"
                                label="Transport"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTechnical"
                                label="Technical"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterFestival"
                                label="Festival"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTiffin"
                                label="Tiffin"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterWash"
                                label="Wash"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterIncentive"
                                label="Incentive"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterOthers"
                                label="Others"
                                type="number"
                          />
                        </v-col>
                      </v-row>

                          <!-- Deduction Section -->
                          <v-divider class="my-4"></v-divider>
                          <v-card-title class="text-subtitle-2 bg-grey-lighten-4 pa-2">Deduction</v-card-title>
                          <v-row class="pa-1">
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTaxDeduct"
                                label="Tax Deduct"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterPF"
                                label="PF"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterCarUse"
                                label="Car Use"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterGasBill"
                                label="Gas Bill"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterElectricityBill"
                                label="Electricity Bill"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTelephoneBill"
                                label="Telephone Bill"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterInsurance"
                                label="Insurance"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterOthersDeduct"
                                label="Others Deduct"
                                type="number"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                    </v-col>
                  </v-row>

                  <!-- Status and Action Buttons -->
                  <v-row class="ma-0 mt-0">
                    <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="status"
                        :items="statusOptions"
                        :item-title="(item) => `${item.text}`"
                        item-value="value"
                        :loading="loading"
                        autocomplete="off"
                        clearable
                        hide-details="auto"
                      >
                        <template #label>
                          Status
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col lg="9" md="9" cols="12" class="d-flex justify-end align-center">
                      <v-btn
                        color="error"
                        variant="outlined"
                        @click="resetForm"
                        :disabled="loading"
                        class="mr-2"
                      >
                        Reset
                      </v-btn>
                      <v-btn 
                        type="submit"
                        color="success" 
                        variant="flat" 
                        :loading="loading"
                        :disabled="loading"
                        prepend-icon="mdi-content-save"
                      >
                        SAVE
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { toast } from 'vue3-toastify'
import { hrmService } from '@/services/hrmService'

// Store and Router
const store = useStore()
const router = useRouter()

// Temporary workaround for getEmployeeDetails function
const getEmployeeDetails = async (employeeId) => {
  try {
    const response = await hrmService.apiClient.get(`/auth/hrm/get-employee-details/${employeeId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

// Helper function to get package name from ID
const getPackageName = (packageId) => {
  if (!packageId) return null
  const packageOption = packageOptions.value.find(pkg => pkg.id === packageId)
  return packageOption ? packageOption.name : null
}

// Panels
const panel = ref([0])
const panel1 = ref([0])
const panel2 = ref([0])

// Loading state
const loading = ref(false)
const employeesLoading = ref(false)

// Form validation
const addIncrement = ref(null)

// Form fields with validation
const company_id = ref(null)
const branch_id = ref(null)
const employee_id = ref(null)
const ref_no = ref('')
const increment_type = ref('normal')
const increment_date = ref('')
const effect_date = ref('')
const current_basic_salary = ref(0)
const new_basic_salary = ref(0)
const increment_amount = ref(0)
const status = ref('active')
const remarks = ref('')

// Package options
const beforePackage = ref(null)
const afterPackage = ref(null)

// Before increment salary components
const beforeGrossSalary = ref(0)
const beforeBasic = ref(0)
const beforeHouseRent = ref(0)
const beforeMedical = ref(0)
const beforeEducation = ref(0)
const beforeMobile = ref(0)
const beforeTransport = ref(0)
const beforeTechnical = ref(0)
const beforeFestival = ref(0)
const beforeTiffin = ref(0)
const beforeWash = ref(0)
const beforeIncentive = ref(0)
const beforeOthers = ref(0)

// After increment salary components
const afterGrossSalary = ref(0)
const afterBasic = ref(0)
const afterHouseRent = ref(0)
const afterMedical = ref(0)
const afterEducation = ref(0)
const afterMobile = ref(0)
const afterTransport = ref(0)
const afterTechnical = ref(0)
const afterFestival = ref(0)
const afterTiffin = ref(0)
const afterWash = ref(0)
const afterIncentive = ref(0)
const afterOthers = ref(0)

// Before increment deductions
const beforeTaxDeduct = ref(0)
const beforePF = ref(0)
const beforeCarUse = ref(0)
const beforeGasBill = ref(0)
const beforeElectricityBill = ref(0)
const beforeTelephoneBill = ref(0)
const beforeInsurance = ref(0)
const beforeOthersDeduct = ref(0)

// After increment deductions
const afterTaxDeduct = ref(0)
const afterPF = ref(0)
const afterCarUse = ref(0)
const afterGasBill = ref(0)
const afterElectricityBill = ref(0)
const afterTelephoneBill = ref(0)
const afterInsurance = ref(0)
const afterOthersDeduct = ref(0)

// Employee details
const employeeDetails = reactive({
  emp_id: '',
  name: '',
  department: '',
  designation: '',
  joining_date: '',
  mobile: '',
  email: '',
  employee_type: ''
})

// Dropdown options
const companies = ref([])
const branches = ref([])
const employees = ref([])

const incrementTypes = ref([
  { text: 'Normal', value: 'normal' },
  { text: 'Performance', value: 'performance' },
  { text: 'Promotion', value: 'promotion' },
  { text: 'Special', value: 'special' }
])

const statusOptions = ref([
  { text: 'Active', value: 'active' },
  { text: 'Inactive', value: 'inactive' }
])

const packageOptions = ref([
  { id: 1, name: 'Basic Package' },
  { id: 2, name: 'Standard Package' },
  { id: 3, name: 'Premium Package' },
  { id: 4, name: 'Executive Package' },
  { id: 5, name: 'Enhanced Package' }
])

// Methods
const loadCompanies = async () => {
  try {
    const response = await hrmService.getCompanies()
    companies.value = response.data || []
  } catch (error) {
    // Companies loading failed
  }
}

const loadBranches = async () => {
  if (!company_id.value.value) return
  
  try {
    const response = await hrmService.getBranchesByCompany(company_id.value.value)
    branches.value = response.data || []
  } catch (error) {
    // Branches loading failed
  }
}

const loadEmployees = async () => {
  employeesLoading.value = true
  try {
    const response = await hrmService.getEmployees()
    
    if (response.success && response.data) {
      employees.value = response.data
      
    } else if (response.data) {
      employees.value = response.data
    } else {
      employees.value = []
      toast.error('No employee data found in response')
    }
  } catch (error) {
    employees.value = []
    toast.error(`Failed to load employees: ${error.message || 'Unknown error'}`)
  } finally {
    employeesLoading.value = false
  }
}

const loadEmployeeDetails = async () => {
  if (!employee_id.value) return
  
  try {
    // Get details from the selected employee in the dropdown
    const selectedEmployee = employees.value.find(emp => emp.id === employee_id.value)
    if (selectedEmployee) {
      Object.assign(employeeDetails, {
        emp_id: selectedEmployee.code || selectedEmployee.employee_code || selectedEmployee.emp_id || '',
        name: selectedEmployee.name || '',
        department: selectedEmployee.department?.name || selectedEmployee.department || '',
        designation: selectedEmployee.designation?.name || selectedEmployee.designation || '',
        joining_date: selectedEmployee.joining_date || '',
        mobile: selectedEmployee.mobile || '',
        email: selectedEmployee.email || '',
        employee_type: selectedEmployee.employeeType?.name || selectedEmployee.employee_type?.name || selectedEmployee.employee_type || ''
      })
    }
    
    // Try to get more detailed info from API (optional)
    try {
      if (typeof getEmployeeDetails === 'function') {
        const response = await getEmployeeDetails(employee_id.value)
        
        if (response.success && response.data) {
          const emp = response.data
          Object.assign(employeeDetails, {
            emp_id: emp.code || emp.employee_code || emp.emp_id || employeeDetails.emp_id,
            name: emp.name || employeeDetails.name,
            department: emp.department?.name || emp.department || employeeDetails.department,
            designation: emp.designation?.name || emp.designation || employeeDetails.designation,
            joining_date: emp.joining_date || employeeDetails.joining_date,
            mobile: emp.mobile || employeeDetails.mobile,
            email: emp.email || employeeDetails.email,
            employee_type: emp.employeeType?.name || emp.employee_type?.name || emp.employee_type || employeeDetails.employee_type
          })
        }
      }
    } catch (apiError) {
      // Use selection data as fallback
    }
    
    // Always try to load salary information
    await loadCurrentSalary()
  } catch (error) {
    // Still try to load salary even if there's an error
    await loadCurrentSalary()
  }
}

const loadCurrentSalary = async () => {
  try {
    const response = await hrmService.getEmployeeSalaryInfo(employee_id.value)
    
    if (response.success && response.data && response.data.length > 0) {
      // Get the most recent salary record (first in the array since it's ordered by effect_date desc)
      const salaryData = response.data[0]
      
      // Update basic salary fields
      current_basic_salary.value = salaryData.basic_salary || 0
      
      // Populate package information
      if (salaryData.package) {
        console.log('Package from salary data:', salaryData.package)
        console.log('Available package options:', packageOptions.value)
        const matchingPackage = getPackageIdByName(salaryData.package)
        beforePackage.value = matchingPackage
        console.log('Matched package ID:', matchingPackage)
      } else {
        beforePackage.value = null
      }
      
      // Populate before increment salary components
      beforeGrossSalary.value = salaryData.gross_salary || 0
      beforeBasic.value = salaryData.basic_salary || 0
      beforeHouseRent.value = salaryData.house_rent || 0
      beforeMedical.value = salaryData.medical || 0
      beforeEducation.value = salaryData.education || 0
      beforeMobile.value = salaryData.mobile || 0
      beforeTransport.value = salaryData.transport || 0
      beforeTechnical.value = salaryData.technical || 0
      beforeFestival.value = salaryData.festival_allowance || 0
      beforeTiffin.value = salaryData.tiffin || 0
      beforeWash.value = salaryData.wash || 0
      beforeIncentive.value = salaryData.incentive || 0
      beforeOthers.value = salaryData.others || 0
      
      // Populate before increment deductions
      beforeTaxDeduct.value = salaryData.tax_deducted || 0
      beforePF.value = salaryData.pf_provident_fund || 0
      beforeCarUse.value = salaryData.car_use || 0
      beforeGasBill.value = salaryData.gas_bill || 0
      beforeElectricityBill.value = salaryData.electricity_bill || 0
      beforeTelephoneBill.value = salaryData.telephone_bill || 0
      beforeInsurance.value = salaryData.insurance || 0
      beforeOthersDeduct.value = salaryData.others_deducted || salaryData.others_deduct || 0
      
      
    } else {
      toast.warning('No salary information found for this employee')
    }
  } catch (error) {
    toast.error('Failed to load employee salary information')
  }
}

const calculateIncrementAmount = () => {
  const current = parseFloat(current_basic_salary.value) || 0
  const newSalary = parseFloat(new_basic_salary.value) || 0
  increment_amount.value = newSalary - current
}

// Watch for salary changes
watch(() => new_basic_salary.value, () => {
  calculateIncrementAmount()
})

const submit = async () => {
  loading.value = true
  
  try {
    // Validate required fields
    if (!employee_id.value) {
      toast.error('Please select an employee')
      return
    }
    
    if (!ref_no.value) {
      toast.error('Please enter reference number')
      return
    }
    
    if (!increment_date.value) {
      toast.error('Please select increment date')
      return
    }
    
    if (!effect_date.value) {
      toast.error('Please select effect date')
      return
    }
    
    if (!new_basic_salary.value || new_basic_salary.value <= current_basic_salary.value) {
      toast.error('New basic salary must be greater than current basic salary')
      return
    }

    const incrementData = {
      employee_id: employee_id.value,
      ref_no: ref_no.value,
      increment_type: increment_type.value,
      increment_date: increment_date.value,
      effect_date: effect_date.value,
      current_basic_salary: current_basic_salary.value,
      new_basic_salary: new_basic_salary.value,
      increment_amount: increment_amount.value,
      status: status.value,
      remarks: remarks.value,
      
      // Note: Before increment data is now pulled from salary table dynamically
      
      // After increment data
      after_package: getPackageName(afterPackage.value),
      after_salary: {
        gross_salary: afterGrossSalary.value,
        basic: afterBasic.value,
        house_rent: afterHouseRent.value,
        medical: afterMedical.value,
        education: afterEducation.value,
        mobile: afterMobile.value,
        transport: afterTransport.value,
        technical: afterTechnical.value,
        festival: afterFestival.value,
        tiffin: afterTiffin.value,
        wash: afterWash.value,
        incentive: afterIncentive.value,
        others: afterOthers.value
      },
      after_deduction: {
        tax_deduct: afterTaxDeduct.value,
        pf: afterPF.value,
        car_use: afterCarUse.value,
        gas_bill: afterGasBill.value,
        electricity_bill: afterElectricityBill.value,
        telephone_bill: afterTelephoneBill.value,
        insurance: afterInsurance.value,
        others_deduct: afterOthersDeduct.value
      }
    }
    
    let response
    const editingIncrement = store.getters.getEditingIncrement
    
       if (editingIncrement) {
         // Update existing increment
         response = await hrmService.updateIncrement(editingIncrement.id, incrementData)
         if (response.success) {
           toast.success('Increment updated successfully!')
           store.commit('clearEditingIncrement')
         }
       } else {
      // Create new increment
      response = await hrmService.saveOrUpdateIncrement(incrementData)
      if (response.success) {
        toast.success('Increment saved successfully!')
      }
    }
    
    if (response.success) {
      resetForm()
      router.push('/hrm/increment-list')
    } else {
      toast.error(response.message || 'Failed to save increment')
    }
    
  } catch (error) {
    toast.error(error.response?.data?.message || 'Failed to save increment')
  } finally {
    loading.value = false
  }
}

const resetForm = () => {
  employee_id.value = null
  ref_no.value = ''
  increment_type.value = 'normal'
  increment_date.value = ''
  effect_date.value = ''
  current_basic_salary.value = 0
  new_basic_salary.value = 0
  increment_amount.value = 0
  status.value = 'active'
  remarks.value = ''
  
  // Reset package selections
  beforePackage.value = null
  afterPackage.value = null
  
  // Reset before salary components
  beforeGrossSalary.value = 0
  beforeBasic.value = 0
  beforeHouseRent.value = 0
  beforeMedical.value = 0
  beforeEducation.value = 0
  beforeMobile.value = 0
  beforeTransport.value = 0
  beforeTechnical.value = 0
  beforeFestival.value = 0
  beforeTiffin.value = 0
  beforeWash.value = 0
  beforeIncentive.value = 0
  beforeOthers.value = 0
  
  // Reset after salary components
  afterGrossSalary.value = 0
  afterBasic.value = 0
  afterHouseRent.value = 0
  afterMedical.value = 0
  afterEducation.value = 0
  afterMobile.value = 0
  afterTransport.value = 0
  afterTechnical.value = 0
  afterFestival.value = 0
  afterTiffin.value = 0
  afterWash.value = 0
  afterIncentive.value = 0
  afterOthers.value = 0
  
  // Reset before deductions
  beforeTaxDeduct.value = 0
  beforePF.value = 0
  beforeCarUse.value = 0
  beforeGasBill.value = 0
  beforeElectricityBill.value = 0
  beforeTelephoneBill.value = 0
  beforeInsurance.value = 0
  beforeOthersDeduct.value = 0
  
  // Reset after deductions
  afterTaxDeduct.value = 0
  afterPF.value = 0
  afterCarUse.value = 0
  afterGasBill.value = 0
  afterElectricityBill.value = 0
  afterTelephoneBill.value = 0
  afterInsurance.value = 0
  afterOthersDeduct.value = 0
  
  Object.assign(employeeDetails, {
    emp_id: '',
    name: '',
    department: '',
    designation: '',
    joining_date: '',
    mobile: '',
    email: '',
    employee_type: ''
  })
}

// Generate reference number
const generateReferenceNumber = async () => {
  try {
    const response = await hrmService.generateIncrementReferenceNumber()
    if (response.success) {
      ref_no.value = response.data.ref_no
    }
  } catch (error) {
    // Reference number generation failed, user can enter manually
  }
}

const loadEditingIncrement = async (incrementData) => {
  try {
    console.log('Loading editing increment data:', incrementData)
    console.log('Current salary data available:', !!incrementData.current_salary)
    console.log('After package data:', incrementData.after_package)
    console.log('All increment fields:', Object.keys(incrementData))
    
    // Populate basic increment data
    employee_id.value = incrementData.employee?.id || incrementData.employee_id
    ref_no.value = incrementData.ref_no
    increment_type.value = incrementData.increment_type
    increment_date.value = formatDateForInput(incrementData.increment_date)
    effect_date.value = formatDateForInput(incrementData.effect_date)
    current_basic_salary.value = incrementData.current_basic_salary
    new_basic_salary.value = incrementData.new_basic_salary
    increment_amount.value = incrementData.amount || incrementData.increment_amount
    status.value = incrementData.status
    remarks.value = incrementData.remarks || ''
    
    
    // Load employee details
    await loadEmployeeDetails()
    
    // Load current salary data from the API response (if available)
    if (incrementData.current_salary) {
      const salaryData = incrementData.current_salary
      console.log('Loading current salary data from API response:', salaryData)
      
      // Populate before increment salary (read-only, from current salary)
      console.log('Package from current salary data:', salaryData.package)
      beforePackage.value = getPackageIdByName(salaryData.package)
      console.log('Set beforePackage.value to:', beforePackage.value)
      beforeGrossSalary.value = salaryData.gross_salary || 0
      beforeBasic.value = salaryData.basic_salary || 0
      beforeHouseRent.value = salaryData.house_rent || 0
      beforeMedical.value = salaryData.medical || 0
      beforeEducation.value = salaryData.education || 0
      beforeMobile.value = salaryData.mobile || 0
      beforeTransport.value = salaryData.transport || 0
      beforeTechnical.value = salaryData.technical || 0
      beforeFestival.value = salaryData.festival_allowance || 0
      beforeTiffin.value = salaryData.tiffin || 0
      beforeWash.value = salaryData.wash || 0
      beforeIncentive.value = salaryData.incentive || 0
      beforeOthers.value = salaryData.others || 0
      
      beforeTaxDeduct.value = salaryData.tax_deducted || 0
      beforePF.value = salaryData.pf_provident_fund || 0
      beforeCarUse.value = salaryData.car_use || 0
      beforeGasBill.value = salaryData.gas_bill || 0
      beforeElectricityBill.value = salaryData.electricity_bill || 0
      beforeTelephoneBill.value = salaryData.telephone_bill || 0
      beforeInsurance.value = salaryData.insurance || 0
      beforeOthersDeduct.value = salaryData.others_deducted || 0
    } else {
      // If current salary data is not available, try to fetch it
      console.log('No current salary data in API response, fetching from employee salary API')
      if (employee_id.value) {
        try {
          await loadCurrentSalary()
        } catch (error) {
          console.error('Failed to load current salary data:', error)
        }
      }
    }
    
    // Populate after increment salary data (if available)
    console.log('After package from increment data:', incrementData.after_package)
    if (incrementData.after_package) {
      const afterPackageId = getPackageIdByName(incrementData.after_package)
      afterPackage.value = afterPackageId
      console.log('Set afterPackage.value to:', afterPackageId)
    } else {
      console.log('No after_package found in increment data')
      afterPackage.value = null
    }
    afterGrossSalary.value = incrementData.after_gross_salary || 0
    afterBasic.value = incrementData.after_basic || 0
    afterHouseRent.value = incrementData.after_house_rent || 0
    afterMedical.value = incrementData.after_medical || 0
    afterEducation.value = incrementData.after_education || 0
    afterMobile.value = incrementData.after_mobile || 0
    afterTransport.value = incrementData.after_transport || 0
    afterTechnical.value = incrementData.after_technical || 0
    afterFestival.value = incrementData.after_festival || 0
    afterTiffin.value = incrementData.after_tiffin || 0
    afterWash.value = incrementData.after_wash || 0
    afterIncentive.value = incrementData.after_incentive || 0
    afterOthers.value = incrementData.after_others || 0
    
    afterTaxDeduct.value = incrementData.after_tax_deduct || 0
    afterPF.value = incrementData.after_pf || 0
    afterCarUse.value = incrementData.after_car_use || 0
    afterGasBill.value = incrementData.after_gas_bill || 0
    afterElectricityBill.value = incrementData.after_electricity_bill || 0
    afterTelephoneBill.value = incrementData.after_telephone_bill || 0
    afterInsurance.value = incrementData.after_insurance || 0
    afterOthersDeduct.value = incrementData.after_others_deduct || 0
    
    
    toast.success('Increment data loaded for editing')
  } catch (error) {
    console.error('Error loading increment data:', error)
    toast.error('Failed to load increment data for editing')
  }
}

const formatDateForInput = (dateString) => {
  if (!dateString) return ''
  try {
    const date = new Date(dateString)
    return date.toISOString().split('T')[0] // Returns YYYY-MM-DD format
  } catch (error) {
    return ''
  }
}

const getPackageIdByName = (packageName) => {
  if (!packageName) return null
  
  console.log('Matching package:', packageName)
  console.log('Available packages:', packageOptions.value)
  
  // Try exact match first
  let packageOption = packageOptions.value.find(pkg => pkg.name === packageName)
  
  // If no exact match, try partial match
  if (!packageOption) {
    packageOption = packageOptions.value.find(pkg => 
      packageName.toLowerCase().includes(pkg.name.toLowerCase()) ||
      pkg.name.toLowerCase().includes(packageName.toLowerCase())
    )
  }
  
  // If still no match, try to find by keywords
  if (!packageOption) {
    const lowerPackageName = packageName.toLowerCase()
    if (lowerPackageName.includes('basic')) {
      packageOption = packageOptions.value.find(pkg => pkg.name.toLowerCase().includes('basic'))
    } else if (lowerPackageName.includes('standard')) {
      packageOption = packageOptions.value.find(pkg => pkg.name.toLowerCase().includes('standard'))
    } else if (lowerPackageName.includes('premium')) {
      packageOption = packageOptions.value.find(pkg => pkg.name.toLowerCase().includes('premium'))
    } else if (lowerPackageName.includes('executive')) {
      packageOption = packageOptions.value.find(pkg => pkg.name.toLowerCase().includes('executive'))
    } else if (lowerPackageName.includes('enhanced')) {
      packageOption = packageOptions.value.find(pkg => pkg.name.toLowerCase().includes('premium'))
    }
  }
  
  console.log('Matched package option:', packageOption)
  return packageOption ? packageOption.id : null
}



// Initialize
onMounted(async () => {
  await loadEmployees()
  
  // Check if we're editing an existing increment
  const editingIncrement = store.getters.getEditingIncrement
  
  if (editingIncrement) {
    await loadEditingIncrement(editingIncrement)
  } else {
    await generateReferenceNumber()
  }
})

onBeforeUnmount(() => {
  store.commit('clearEditingIncrement')
  resetForm()
})
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}

/* Reduce spacing between elements */
.v-container {
  padding: 8px !important;
}

.v-expansion-panels {
  margin-bottom: 4px !important;
}

.v-expansion-panel-text__wrapper {
  padding: 4px 8px !important;
}

.v-card {
  margin-bottom: 4px !important;
}

.v-card-title {
  padding: 8px 12px !important;
  margin-bottom: 0 !important;
}

/* Reduce form field spacing */
.v-form {
  padding: 4px !important;
}

/* Compact spacing for better density */
.v-row {
  margin: 0 !important;
}

.v-col {
  padding: 2px !important;
}
</style>